export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const LOAD_ACCOUNTS_SUCCESS = 'LOAD_ACCOUNTS_SUCCESS';
export const SAVE_ACCOUNT_SUCCESS = 'SAVE-ACCOUNT_SUCCESS';




// WEBPACK FOOTER //
// ./src/actions/actionTypes.js